// Central content + brand data for the Echo Bravo landing page.

export const COMPANY = {
  name: "Echo Bravo",
  legalName: "Echo Bravo Maritime Consultancy",
  tagline: "Maritime Consultancy & Strategic Advisory",
  email: "management@echobravomaritime.com",
  phone: "+971 50 540 17 81",
  phoneHref: "+971505401781",
  address: [
    "BC-891938, 26th Floor",
    "Amber Gem Tower, Ajman",
    "United Arab Emirates",
  ],
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Why Echo Bravo", href: "#why" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Contact", href: "#contact" },
];

export const HERO_STATS = [
  { value: "120+", label: "Vessels advised" },
  { value: "50+", label: "Successful transactions" },
  { value: "100%", label: "Compliance success" },
  { value: "24/7", label: "Operations desk" },
];

export const VALUES = [
  { title: "Integrity", text: "Independent, conflict-free advice in every engagement." },
  { title: "Precision", text: "Decisions grounded in data, class rules and sea-going reality." },
  { title: "Partnership", text: "We sit on your side of the table, from bridge to boardroom." },
  { title: "Accountability", text: "Measurable outcomes you can audit and defend." },
];

export const WHY_CHOOSE = [
  {
    title: "Industry Expertise",
    text: "Decades of combined sea-going command and shore-side leadership across tankers, bulkers, container and offshore fleets.",
  },
  {
    title: "International Perspective",
    text: "A global advisory desk operating across major maritime hubs, flag administrations and the world's busiest trade lanes.",
  },
  {
    title: "Tailored Solutions",
    text: "Bespoke advisory mapped precisely to your fleet profile, cargo mix and long-term commercial objectives.",
  },
  {
    title: "Operational Excellence",
    text: "Measurable gains in efficiency, compliance and uptime, delivered through a rigorous, repeatable methodology.",
  },
];

export const CASE_STUDIES = [
  {
    sector: "Tanker operator · 18 vessels",
    title: "Fleet-Wide Fuel Efficiency Programme",
    metric: "−12%",
    metricLabel: "bunker spend",
    text: "Hull, propeller and voyage-planning optimisation rolled out across the fleet, cutting annual fuel consumption while improving on-time performance.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/be4b6ead-eecf-46db-b204-8360a1346120/images/9f5a3e4bc9345c6975976fc3b2861c0eb6c9404d5226f281af7268bfbb4c0e94.jpeg",
  },
  {
    sector: "Bulk carrier fleet · 11 vessels",
    title: "MARPOL Annex VI Readiness",
    metric: "100%",
    metricLabel: "audit pass rate",
    text: "End-to-end emissions compliance, CII rating strategy and audit-ready documentation prepared ahead of a major flag-state inspection cycle.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/be4b6ead-eecf-46db-b204-8360a1346120/images/cfb28f1d94c5bd75de725f01a9f8cef4156ff1c33246f36266b2701ef135bd69.jpeg",
  },
  {
    sector: "Container line · regional",
    title: "Drydock & Retrofit Optimisation",
    metric: "9 days",
    metricLabel: "saved per docking",
    text: "Re-engineered drydock scope, sequencing and yard liaison to compress repair windows and return revenue tonnage to service faster.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/be4b6ead-eecf-46db-b204-8360a1346120/images/0d8032a129723301ff9b4af401da62aabb0a3edd7d969d3b125003e357d18f8c.jpeg",
  },
];

export const SERVICE_OPTIONS = [
  "Fleet Advisory",
  "Marine Operations Consulting",
  "Regulatory Compliance & Technical Advisory",
  "Commercial Advisory and Brokering Services",
  "Risk Assessment & Management",
  "Maritime Strategy Consulting",
  "General Enquiry",
];

export const IMAGES = {
  hero:
    "https://images.pexels.com/photos/14810111/pexels-photo-14810111.jpeg?auto=compress&cs=tinysrgb&w=1920",
  about:
    "https://static.prod-images.emergentagent.com/jobs/be4b6ead-eecf-46db-b204-8360a1346120/images/4299bdafe23b6da2ec02d00e152451f3be752cdba9d87b31038f255857720bfc.jpeg",
  whyAccent:
    "https://images.pexels.com/photos/12514724/pexels-photo-12514724.jpeg?auto=compress&cs=tinysrgb&w=1200",
  servicesFeature:
    "https://images.pexels.com/photos/18641968/pexels-photo-18641968.jpeg?auto=compress&cs=tinysrgb&w=1200",
};
